<template>
  <div class="business">
    <div
      ref="crosswisePrint"
      id="crosswisePrint"
      class="crosswisePrint"
      style="border:1px solid #ccc;padding:10px;display:inline-block;"
      v-if="show == 0"
    >
      <!-- <div style="text-align:center;font-size:18px;font-weight: bold;">{{hotleInfo.name}}</div> -->
      <div style="text-align:center;font-size:10px">餐饮交班报表</div>
      <hr style= "border:none;border-top:1px dashed #999;margin:6px 0px"/>
      <div style="text-align: left;font-size:10px;">
        <div style="font-size:10px;">营业日期：{{listQuery.startTime}}至{{listQuery.endTime}}</div>
        <div style="font-size:10px;">打印人：{{employee.name}}</div>
        <div style="font-size:10px;">班次：{{listQuery.shiftCode == 1 ? '早班' :listQuery.shiftCode == 2?'中班':listQuery.shiftCode == 3?'晚班':'夜班'}}</div>
      </div>
      <hr style= "border:none;border-top:1px dashed #999;margin:6px 0px"/>
      <div style="text-align: left;font-weight: bold;font-size:12px">销售</div>
      <hr style= "border:none;border-top:1px dashed #999;margin:6px 0px"/>
      <div style="display:flex;font-size:10px;justify-content: space-between;" v-for="item in reportDateTotal" :key='item.code'>
        <div v-if="item.total_price" style="padding:4px 0px;" >{{item.chinese_desc}}</div>
        <div v-if="item.total_price" style="padding:4px 0px;">{{item.total_price?item.total_price.toFixed(2):'0.00'}}</div>
      </div>
      <div style="padding:10px 0px;display:flex;font-size:12px;justify-content: space-between;font-weight: bold;" >
        <div>合计</div>
        <div>{{reportDateTotalSum?reportDateTotalSum.toFixed(2):'0.00'}}</div>
      </div>
      <div style="text-align: left;font-weight: bold;font-size:12px">收款</div>
      <hr style= "border:none;border-top:1px dashed #999;margin:6px 0px"/>
      <div style="display:flex;font-size:10px;justify-content: space-between;" v-for="item in payTypeTotal" :key='item.productCode'>
        <div  v-if="item.total_price" style="padding:4px 0px;">{{item.productName}}</div>
        <div  v-if="item.total_price" style="padding:4px 0px;">{{item.total_price?item.total_price.toFixed(2):'0.00'}}</div>
      </div>
      <div style="padding:10px 0px;display:flex;font-size:12px;justify-content: space-between;font-weight: bold;" >
        <div>合计</div>
        <div>{{payTypeTotalSum?payTypeTotalSum.toFixed(2):'0.00'}}</div>
      </div>
      <hr style= "border:none;border-top:1px dashed #999;margin:6px 0px;"/>
      <div style="text-align: center;font-size:10px;">打印时间：{{currentTime}}</div>
    </div>
  
    <table v-if="exportShow&& show == 1 && salesTabelTitel.length" id="table"  border="1" cellpadding="0" cellspacing="0" style="width:100%" >
      <thead v-if="exportShow">
        <tr> <th :colspan="salesTabelTitel.length">{{hotelInfo.name}}</th></tr>
        <tr><th :colspan="salesTabelTitel.length" style="font-weight:600;font-size:28px;">营业点交班表</th></tr>
        <tr>

          <th :colspan="salesTabelTitel.length/2">
            <div style="font-weight:600;textAlign:left">
              <template>营业日期:{{listQuery.startTime}} 至 {{listQuery.endTime}}</template>
            </div>
          </th>
          <th style="text-align:right" :colspan="(salesTabelTitel.length+1)/2">打印人:{{employee.name}}  打印时间:{{currentTime}}</th>
        </tr>
       
      </thead>
      <tbody v-if=" salesTabelTitel.length">
        <!-- 销售 -->
        
        <tr><td :colspan="salesTabelTitel.length">销售</td></tr>
          <tr>
            <th v-for="(item,index) in salesTabelTitel" :key="index">{{item.chinese_desc}}</th>
          </tr>
        <tr v-for="tr in handoverSalesTotal" :key="tr.code">
              <td align="center" v-for="(item,index) in salesTabelTitel" :key="index">{{tr[item.code]?typeof(tr[item.code]) == 'number'?tr[item.code].toFixed(2):tr[item.code]:'0.00'}}</td>
          </tr>
        <tr>
          <td align="center" v-for="(td,index) in sumsSalesTotal" :key="index">{{typeof(td) == 'number'? td.toFixed(2):td}}</td>
        </tr>
        <!-- 收款 -->
        <tr><td :colspan="collectionTabelTitel.length">收款</td></tr>
          <tr>
            <th v-for="(item,index) in collectionTabelTitel" :key="index">{{item.productName}}</th>
          </tr>
        <tr v-for="tr in unCollectionAndHouse" :key="tr.outletsCode">
            <td align="center" v-for="(item,index) in collectionTabelTitel" :key="index">{{tr[item.productCode]?typeof(tr[item.productCode]) == 'number'?tr[item.productCode].toFixed(2):tr[item.productCode]:'0.00'}}</td>
          </tr>
        <tr>
          <td align="center" v-for="(td,index) in sumsCollection" :key="index">{{typeof(td) == 'number'? td.toFixed(2):td}}</td>
        </tr>
        <!-- 统计 -->
        <tr><td colspan="6">统计</td></tr>
          <tr>
            <th>营业点</th>
            <th>就餐人数</th>
            <th>人均消费</th>
            <th>餐单数</th>
            <th>每单均价</th>
            <th>账单数</th>
          </tr>
        <tr v-for="tr in statisticsData" :key="tr.outletsCode">
            <td align="center">{{tr.outletsName}}</td>
            <td align="center">{{tr.people_count}}</td>
            <td align="center">{{tr.avgPeoplePrice?tr.avgPeoplePrice.toFixed(2):'0.00'}}</td>
            <td align="center">{{tr.orderCount}}</td>
            <td align="center">{{tr.avgOrderPrice?tr.avgOrderPrice.toFixed(2):'0.00'}}</td>
            <td align="center">{{tr.billCount}}</td>
        </tr>
        <tr>
            <td align="center">合计</td>
            <td align="center">{{statisticsSum.people_count}}</td>
            <td align="center">{{statisticsSum.avgPeoplePrice?(statisticsSum.avgPeoplePrice/statisticsSum.people_count).toFixed(2):'0.00'}}</td>
            <td align="center">{{statisticsSum.orderCount}}</td>
            <td align="center">{{statisticsSum.avgOrderPrice?(statisticsSum.avgOrderPrice/statisticsSum.orderCount).toFixed(2):'0.00'}}</td>
            <td align="center">{{statisticsSum.billCount}}</td>
        </tr>
      </tbody>
    </table>
    <div @click="show = 0" v-if="show == 1" class="rtposi">
      切换纵向交班表
    </div>
     <div @click="show = 1" v-else class="rtposi">
      切换横向交班表
    </div>
  </div>
</template>
<script>
// import DateUtils from '@/utils/DateUtils';
// import getLodop from '@/utils/LodopFuncs.js'
export default {
  data() {
    return {
      show:1,
      hotelInfo:{},
      reportDateTotalSum:'',
      payTypeTotalSum:'',
      payTypeTotal:[],
      reportDateTotal:'',
      currentTime:'',
      hotleInfo: {},
      employee: {},
      handleClose: {},
      shiftCodeFilter: '',
      user: {},
      tableHeadData: [
      
      ],
      tableBodyData: [
       
      ]

    }
  },
   props:{
      reportDateTotal:{
      type:Array,
      default:[]
    },
     payTypeTotal:{
      type:Array,
      default:[]
    },
     reportDateTotalSum:{
      type:String,
    },
    payTypeTotalSum:{
      type:String,

    },
    collectionTabelTitel:{
      type:Array,
      default:[]
    },
    unCollectionAndHouse:{
      type:Array,
      default:[]
    },
    handoverSalesTotal:{
      type:Array,
      default:[]
    },
    salesTabelTitel:{
      type:Array,
      default:[]
    },
    statisticsData:{
      type:Array,
      default:[]
    },
    statisticsSum:{
      type:Object
    },
    sumsCollection:{
      type:Array,
      default:[]
    },
    sumsSalesTotal:{
      type:Array,
      default:[]
    },
    listQuery:{
      type:Object
    },
    exportShow:{
      type:Boolean,
      default:false
    },
  },
  created() {
  
  },
  mounted(){

  },
  beforeDestroy() {
  },
  methods: {
   
    deleteClick(id) {
      this.tableBodyData.splice(id, 1);
    },
    /*   getData(val){
        this.listQuery = Object.assign({},val)
        this.getInit()
      },
      getInit(){
        payTypeTotal(this.listQuery).then(res=>{
          if(res.data.status == 0){
            this.reportDateTotalSum = 0
            this.payTypeTotalSum = 0
            this.reportDateTotal = res.data.data && res.data.data.reportDateTotal.length>0?res.data.data.reportDateTotal:[]
            this.payTypeTotal = res.data.data && res.data.data.payTypeTotal.length>0?res.data.data.payTypeTotal:[]
            this.reportDateTotal.map(v=>{
              this.reportDateTotalSum += v.total_price?v.total_price:0
            })
            this.payTypeTotal.map(v=>{
              this.payTypeTotalSum += v.total_price?v.total_price:0
            })
          }
        })
      },
      todoPrint(type){
        const LODOP = getLodop()
        // 获取大小和宽度
        let width = this.$store.state.user.printWidth?this.$store.state.user.printWidth:2
         if (LODOP) {
            var strFormHtml =
              "<body>" +
              document.getElementById("crosswisePrint").innerHTML +
              "</body>"; //获取打印内容
            LODOP.PRINT_INIT(""); //初始化
            LODOP.SET_PRINT_PAGESIZE(3,'100mm','230mm');
            LODOP.ADD_PRINT_HTM("2%", width+'%', (100-width*2)+'%', "83%", strFormHtml); //设置打印内容
            LODOP.SET_PREVIEW_WINDOW(2, 0, 0, 800, 600, ""); //设置预览窗口模式和大小
            if (type === "preview") {
              LODOP.PREVIEW();
            } else {
              LODOP.PRINT();
            }
         }
      }, */
  }
}
</script>
<style lang="scss" scoped>
.business{
  width: 100%;
  display: flex;
  justify-content: center;
  padding:  20px;
    max-height: calc(100vh - 210px);
  color: #666;
  overflow: auto;
  table{
    color: #666;
  }
  tr{
    width: 100%;
  }
   td {
    line-height: 66px;
    font-size: 24px;
  }
}

.crosswisePrint {
  width: 300px;
  margin: 20px 0; 
}
.rtposi{
  position: absolute;
  right: 20px;
  top: 90px;
  cursor: pointer;
}
</style>
